import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertCatch } from "../../../common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectActiveIpos: "selectActiveIpos [Action]",
  selectActiveIposLoading: "selectActiveIposLoading [Action]",
  selectActiveIposAsync: "selectActiveIposAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
};

export const selectActiveIposReducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectActiveIpos:
      return {
        ...state,
        data: payload,
      };
    case actionTypes.selectActiveIposLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  //responseData.data.response.error_code
  yield put({
    type: actionTypes.selectActiveIposLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "ipo",
    method_type: "select_active_ipos",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    // let isOk = handleNotificationAlertTrySelect(res);
    // if (!isOk) {
    // 	return;
    // }
    yield put({
      type: actionTypes.selectActiveIpos,
      payload: res?.data?.response,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectActiveIposLoading,
      payload: false,
    });
  }
}

export function* selectActiveIpos() {
  yield takeLatest(actionTypes.selectActiveIposAsync, handleWorker);
}
